// get.schema.ts

import { z } from 'zod'

const ItemSchema = z.object({
  id: z.number().int(),
  purchaseOrderId: z.number().int(),
  itemId: z.number().int(),
  remark: z.string(),
  qty: z.number(),
  outstandingQty: z.number(),
  unit: z.string(),
  unitPrice: z.number(),
})

export const Po1010Schema = z.object({
  number: z.string(),
  date: z.string(),
  dueDate: z.string(),
  refNo: z.string().nullable(),
  refDate: z.string().nullable(),
  partyId: z.number().int(),
  shipToName: z.string().nullable(),
  remark: z.string().nullable(),
  status: z.number().int(),
  enableTracking: z.boolean(),
  items: z.array(ItemSchema),
})

export type Po1010Model = z.infer<typeof Po1010Schema>
